export enum PdfSettingsTableRowStyleEnum {
  ZEBRA = 'ZEBRA',
  DIVIDERS = 'DIVIDERS',
  NONE = 'NONE',
}
